import axios from "axios";

export default {
  namespaced: true,
  state: {
    id: null,
    name: '',
    code: '',
    subjectId: null,
    subjectName: '',
    gradeId: null,
    gradeName: '',
    periodId: null,
    periodName: '',
    isShingaku: false,
    fiscalYearWestern: null,
    status: '',
    questionPageCnt: 0,
    presetContentPages: [],
    presetDetails: [],
    questionSheetUrls: [],
    answerUrls: [],
    answerSheetUrls: [],
    hasPdf: false,
  },

  getters: {
    title: state => {
      return state.id ? '編集' : '新規作成'
    },
    url: state => {
      if (state.id) return `api/v1/admin/presets/${state.id}`
      return 'api/v1/admin/presets'
    },
    method: state => {
      return state.id ? 'PUT' : 'POST'
    },
    data: state => {
      return {
        name: state.name,
        code: state.code,
        subject_id: state.subjectId,
        grade_id: state.gradeId,
        period_id: state.periodId,
        is_shingaku: state.isShingaku,
        fiscal_year_western: state.fiscalYearWestern,
      };
    },
  },

  mutations: {
    setPreset(state, payload) {
      state.id = payload.id;
      state.name = payload.name || '';
      state.code = payload.code || '';
      state.subjectId = payload.subject_id;
      state.subjectName = payload.subject_name || '';
      state.gradeId = payload.grade_id;
      state.gradeName = payload.grade_name || '';
      state.periodId = payload.period_id;
      state.periodName = payload.period_name || '';
      state.isShingaku = payload.is_shingaku || false;
      state.fiscalYearWestern = payload.fiscal_year_western || null;
      state.status = payload.status || 'draft';
      state.questionPageCnt = payload.question_page_cnt || 0;
      state.presetContentPages = payload.preset_content_pages || [];
      state.presetDetails = payload.preset_details || [];
      state.questionSheetUrls = payload.question_sheet_urls || [];
      state.answerUrls = payload.answer_urls || [];
      state.answerSheetUrls = payload.answer_sheet_urls || [];
      state.hasPdf = payload.has_pdf || false;
    },
    setName(state, payload) { state.name = payload.name; },
    setCode(state, payload) { state.code = payload.code; },
    setSubjectId(state, payload) { state.subjectId = payload.subjectId; },
    setGradeId(state, payload) { state.gradeId = payload.gradeId; },
    setPeriodId(state, payload) { state.periodId = payload.periodId; },
    setIsShingaku(state, payload) { state.isShingaku = payload.isShingaku; },
    setFiscalYearWestern(state, payload) { state.fiscalYearWestern = payload.fiscalYearWestern; },
    setStatus(state, payload) { state.status = payload.status; },
    initialize(state) {
      state.id = null;
      state.name = '';
      state.code = '';
      state.subjectId = null;
      state.subjectName = '';
      state.gradeId = null;
      state.gradeName = '';
      state.periodId = null;
      state.periodName = '';
      state.isShingaku = false;
      state.fiscalYearWestern = null;
      state.status = '';
      state.questionPageCnt = 0;
      state.presetContentPages = [];
      state.presetDetails = [];
      state.questionSheetUrls = [];
      state.answerUrls = [];
      state.answerSheetUrls = [];
      state.hasPdf = false;
    },
  },

  actions: {
    async validate({ state }) {
      if (!state.name) return { status: 'error', message: 'プリセット名を入力してください' }
      if (!state.subjectId) return { status: 'error', message: '教科を選択してください' }
      return { status: 'success', message: '' }
    },
    async submit({ getters }) {
      const preset = getters.data
      const url = getters.url
      const method = getters.method

      const res = await axios({
        url: url,
        method: method,
        data: { preset: preset },
      })

      const message = method === 'POST' ? '作成が完了しました' : '更新が完了しました'
      return { status: 'success', message: message, data: res.data }
    },
  },
}
